import React from 'react'
import { Button } from 'reactstrap';
import { FormUnit } from './FormUnit';
import { Dialog } from 'primereact/dialog';

export const ModalUnit = (props) => {

    const { modal, closeDialog, loading, method, unit, abbreviation, handleInputChange, saveCreate, saveUpdate, saveDelete } = props;

    const footer = (
        <div className='mt-2' style={{ display: "flex", justifyContent: "flex-end"}}>
            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
            >
                Cancelar
            </Button>

            <Button
                color="primary"
                size="sm"
                disabled={loading}
                onClick={method === "create" ? saveCreate : saveUpdate}
                className={loading ? "progress-bar-animated progress-bar-striped" : ""}
            >
                {
                    loading
                        ? (
                            <>
                                <i className="fa fa-spinner fa-spin mr-2"></i>
                                {
                                    method === "create"
                                        ? "Guardando..."
                                        : "Actualizando..."
                                }
                            </>
                        )
                        : (
                            method === "create"
                                ? "Guardar"
                                : "Actualizar"
                        )
                }
            </Button>
            
        </div>
    );

    return (
        <Dialog 
            header={
                method === "create" ?
                    "Creación de unidades"
                    : (method === "update") ?
                        "Actualización de unidad"
                        : null
            }
            visible={modal} 
            onHide={closeDialog} 
            closable 
            modal 
            blockScroll 
            className='medium-dialog'
            maskClassName="medium-dialog-mask"
            footer={footer}
        >
       
            {
                method === "create" ?
                    <FormUnit button="Crear nueva unidad" {...{ closeDialog, loading, unit, abbreviation, handleInputChange, methodAction: saveCreate }} />
                    : (method === "update") ?
                        <FormUnit button="Actualizar unidad" {...{ closeDialog, loading, unit, abbreviation, handleInputChange, methodAction: saveUpdate }} />
                        : null
            }
        </Dialog>
    )
}
